/**
 * PursuitsPage: bounties the user is pursuing (tracking to submit against),
 * rendered at /account/pursuits (nested under UserHomepage). Pure composition,
 * no local state or API calls: a components/SubheadedPage headed "active
 * pursuits" containing a components/ItemCollection of type "user-pursuits"
 * (itemType "bounty", statusType "active"). Data fetching happens inside
 * ItemCollection.
 */
import { SubheadedPage } from "@/components/SubheadedPage";
import ItemCollection from "@/components/ItemCollection";

const PursuitsPage = () => {
    return (
        <div className="flex flex-col w-full">
            <SubheadedPage heading="active pursuits">
                <ItemCollection
                    type="user-pursuits"
                    itemType="bounty"
                    statusType="active"
                    format="row"
                    emptyStateText="no active pursuits"
                />
            </SubheadedPage>
        </div>
    );
};

export default PursuitsPage;
